import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/home";
import LayoutPage from "./pages/layout";
import UnAuthorized from "./pages/auth/UnAuthorized";
import PricesPage from "./pages/home/PricesPage";
import ContactUsPage from "./pages/home/ContactUsPage";
import AdminRoute from "./pages/admin/AdminRoute";
import AuthRoute from "./pages/auth/AuthRoute";
import ClientRoute from "./pages/client/ClientRoute";
import { Toaster } from 'react-hot-toast';
import PaymentsRoute from "./pages/payments/PaymentsRoute";

import "./App.css";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LayoutPage />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/unAuthorized" element={<UnAuthorized />} />
          <Route path="prices" element={<PricesPage />} />
          <Route path="contact" element={<ContactUsPage />} />
          {PaymentsRoute}
          {AdminRoute}
          {ClientRoute}
          {AuthRoute}
        </Route>
      </Routes>
      <Toaster position="top-center" reverseOrder={false} />

    </div>
  );
}

export default App;
